import { toast } from "react-toastify";

import api from "../services/api";
import toastError from "../errors/toastError";

// Atalho dos pontos de entrada (cartão do Kanban e orçamento do cartão).
// Desde a Fase 5 da venda única (docs/PLANO-VENDA-UNICA.md) proposta nova é
// VENDA no formato "Proposta completa": do orçamento, ele mesmo troca de
// formato (só em rascunho); do cartão, nasce uma venda ligada a ele. Quem
// chama abre a venda devolvida em /vendas/:id, que é o editor.
export const gerarProposta = async ({ quoteId, cardId, contactId }) => {
	try {
		if (quoteId) {
			const { data } = await api.put(`/quotes/${quoteId}`, {
				format: "proposal",
			});
			toast.success(`Venda nº ${data.number} agora é uma proposta completa.`);
			return data;
		}

		const { data } = await api.post("/sales", {
			contactId,
			cardId,
			source: "kanban",
			format: "proposal",
		});
		toast.success(`Proposta nº ${data.number} criada como venda em rascunho.`);
		return data;
	} catch (err) {
		toastError(err);
		return null;
	}
};
